<template>
  <div class="gov-approval-list-container">
    <!-- 批量操作栏（仅待审核态显示） -->
    <div
      class="batch-action-bar"
      v-if="form_head_uuid === '403e15205bc248f48d8a3626571c4e56' && !loading && orderList.length > 0"
    >
      <div class="batch-left">
        <el-checkbox
          :indeterminate="isIndeterminate"
          :value="isAllChecked"
          @change="toggleSelectAll"
        >
          全选当页（已选 <strong>{{ checkList.length }}</strong> 项）
        </el-checkbox>
      </div>
      <div class="batch-right" v-if="checkList.length > 0">
        <el-button type="primary" size="small" icon="el-icon-check" @click="handleBatchApproval(1)">
          批量通过 ({{ checkList.length }})
        </el-button>
        <el-button size="small" icon="el-icon-close" @click="handleBatchApproval(2)">
          批量驳回 ({{ checkList.length }})
        </el-button>
      </div>
    </div>

    <!-- 加载中骨架屏 -->
    <div v-if="loading" class="approval-skeleton-list">
      <div v-for="i in 3" :key="i" class="sk-order-card">
        <div class="sk-header">
          <div class="sk-bar w-30"></div>
          <div class="sk-bar w-20"></div>
        </div>
        <div class="sk-body">
          <div class="sk-img"></div>
          <div class="sk-details">
            <div class="sk-bar w-60"></div>
            <div class="sk-bar w-40"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 真实数据卡片列表 -->
    <div class="orderBox" v-else-if="orderList && orderList.length > 0">
      <div class="orderTableHeader">
        <span class="col-goods">审批物料明细</span>
        <span class="col-price">采购单价</span>
        <span class="col-num">数量(单位)</span>
        <span class="col-total">小计金额</span>
      </div>

      <ul class="orderList">
        <li v-for="item in orderList" :key="'order' + item.id" class="order-card-item">
          <!-- 订单管理类型 -->
          <template v-if="item.form_head_uuid === '436ae44d1c60475a9b4009ca40edc11e'">
            <div class="orderHeader" @click="handleCheck(item)">
              <div class="header-left">
                <el-checkbox
                  v-if="form_head_uuid === '403e15205bc248f48d8a3626571c4e56'"
                  :value="checkItem(item)"
                  @click.native.stop
                  @change="handleCheck(item)"
                ></el-checkbox>
                <span class="orderTime">
                  <i class="el-icon-document"></i>
                  {{ item.name }}
                </span>
              </div>
              <div class="header-right">
                <span class="status-badge" :class="getStatusBadgeClass()">
                  {{ getStatusText() }}
                </span>
              </div>
            </div>

            <div
              class="orderDetail"
              v-for="(order, idx) in (item.fields_value_json_show ? item.fields_value_json_show.cpimejxmehpaxrrz : [])"
              :key="idx"
            >
              <img
                :src="
                  order.mnkt8dkjryhvdej3 && order.mnkt8dkjryhvdej3.length > 0
                    ? order.mnkt8dkjryhvdej3[0].url
                    : ''
                "
                alt="商品图片"
                class="goods-thumb"
              />
              <div class="goodsName">
                <p
                  @click.stop="navTo('/mall/goods/' + (order.whfmbyuc1i2pavi4 && order.whfmbyuc1i2pavi4[0] ? order.whfmbyuc1i2pavi4[0].id : ''))"
                  v-if="order.whfmbyuc1i2pavi4 && order.whfmbyuc1i2pavi4.length > 0"
                >
                  {{ order.whfmbyuc1i2pavi4[0].value }}
                </p>
              </div>
              <span class="unitPrice">￥{{ order.rojkudmmvpzinpar || 0 }}</span>
              <span class="num">
                {{ order.mcuilzaudpe3shlc }}
                {{ order.kq1qbbk7dulmlghs ? `(${order.kq1qbbk7dulmlghs})` : '' }}
              </span>
              <span class="amount">￥{{ order.nvbfzg88gv88hnt9 }}</span>
            </div>
          </template>

          <!-- 单位商品管理类型 -->
          <template v-else-if="item.form_head_uuid === '4b9b935758484c01bb3d8e2d1e08211f'">
            <div class="orderHeader" @click="handleCheck(item)">
              <div class="header-left">
                <el-checkbox
                  v-if="form_head_uuid === '403e15205bc248f48d8a3626571c4e56'"
                  :value="checkItem(item)"
                  @click.native.stop
                  @change="handleCheck(item)"
                ></el-checkbox>
                <span class="orderTime">
                  <i class="el-icon-time"></i>
                  {{ item.fields_value_json_show ? item.fields_value_json_show.created_at : '' }}
                </span>
                <span class="orderId" v-if="item.fields_value_json_show">
                  商品识别码：{{ item.fields_value_json_show['cl0aot0gizkouc7p'] }}
                </span>
              </div>
              <div class="header-right">
                <span class="status-badge" :class="getStatusBadgeClass()">
                  {{ getStatusText() }}
                </span>
              </div>
            </div>

            <div class="orderDetail" v-if="item.fields_value_json_show">
              <img
                :src="
                  item.fields_value_json_show.in7kxcfnzrfwav2r &&
                  item.fields_value_json_show.in7kxcfnzrfwav2r.length > 0
                    ? item.fields_value_json_show.in7kxcfnzrfwav2r[0].url
                    : ''
                "
                alt="商品图片"
                class="goods-thumb"
              />
              <div class="goodsName">
                <p @click.stop="navTo('/mall/goods/' + item.fields_value_json_show.id)">
                  {{
                    item.fields_value_json_show['6qujfllbbkwsj6t1'] &&
                    item.fields_value_json_show['6qujfllbbkwsj6t1'].length > 0 &&
                    item.fields_value_json_show['6qujfllbbkwsj6t1'][0]
                      ? item.fields_value_json_show['6qujfllbbkwsj6t1'][0].value
                      : ''
                  }}
                </p>
              </div>
              <span class="unitPrice">￥{{ item.fields_value_json_show.f93blbqlvdtdt65v || 0 }}</span>
              <span class="num">
                1
                {{
                  item.fields_value_json_show.y8cegh2yyvvqbzwo
                    ? `(${item.fields_value_json_show.y8cegh2yyvvqbzwo})`
                    : ''
                }}
              </span>
              <span class="amount">￥{{ item.fields_value_json_show.f93blbqlvdtdt65v || 0 }}</span>
            </div>
          </template>

          <!-- 底部汇总与审批动作 -->
          <div class="orderfooter">
            <div class="footer-left">
              <span class="total-sum" v-if="item.fields_value_json_show && item.fields_value_json_show.p6zxciihiw61mebe">
                申请总金额：<em>￥{{ item.fields_value_json_show.p6zxciihiw61mebe }}</em>
              </span>
            </div>
            <!-- 仅在“审核中”显示单个通过/驳回 -->
            <div class="footer-right" v-if="form_head_uuid === '403e15205bc248f48d8a3626571c4e56'">
              <el-button type="primary" size="small" icon="el-icon-check" @click="handleApproval(item, 1)">
                通过审批
              </el-button>
              <el-button size="small" icon="el-icon-close" @click="handleApproval(item, 2)">
                驳回申请
              </el-button>
            </div>
          </div>
        </li>
      </ul>

      <!-- 统一分页 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 规范空状态 -->
    <div class="empty-gov-state" v-else>
      <div class="icon-circle">
        <i class="el-icon-document-checked"></i>
      </div>
      <p class="empty-title">暂无相关{{ getStatusText() }}记录</p>
      <p class="empty-sub">当前筛选状态下没有任何待处理或历史审批数据</p>
    </div>
  </div>
</template>

<script>
import {
  todolist,
  todolistShow,
  checktodo,
  approveAllowApprovalBatchAction,
  getQueueText,
} from "@/api/platform";

export default {
  name: "ApprovalList",
  props: {
    form_head_uuid: {
      type: String,
      default: "",
    },
    form_id: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      orderList: [],
      loading: true,
      page: 1,
      total: 0,
      limit: 20,
      application_id: "270ab0c29e5411ee9b8b0242321230b4",
      checkList: [],
      loadingInstance: null,
      timer: null,
    };
  },
  computed: {
    isAllChecked() {
      return this.orderList.length > 0 && this.checkList.length === this.orderList.length;
    },
    isIndeterminate() {
      return this.checkList.length > 0 && this.checkList.length < this.orderList.length;
    }
  },
  created() {
    this.todolist();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    getStatusText() {
      if (this.form_head_uuid === '403e15205bc248f48d8a3626571c4e56') return '审核中';
      if (this.form_head_uuid === '91e9bb4eac0a48b38e8327cc9c6c23de') return '审核成功';
      if (this.form_head_uuid === '33d336e546644de7afb25e1989757d93') return '审核驳回';
      return '审批记录';
    },
    getStatusBadgeClass() {
      if (this.form_head_uuid === '403e15205bc248f48d8a3626571c4e56') return 'badge-reviewing';
      if (this.form_head_uuid === '91e9bb4eac0a48b38e8327cc9c6c23de') return 'badge-approved';
      if (this.form_head_uuid === '33d336e546644de7afb25e1989757d93') return 'badge-rejected';
      return '';
    },
    checkItem(value) {
      return this.checkList.some((el) => el.id === value.id);
    },
    toggleSelectAll(val) {
      if (val) {
        this.checkList = [...this.orderList];
      } else {
        this.checkList = [];
      }
    },
    handleCheck(value) {
      if (this.form_head_uuid !== "403e15205bc248f48d8a3626571c4e56") return;
      let i = this.checkList.findIndex((el) => el.id === value.id);
      if (i !== -1) {
        this.checkList.splice(i, 1);
      } else {
        this.checkList.push(value);
      }
    },
    async todolist() {
      this.loading = true;
      try {
        let obj = {
          application_id: this.application_id,
          form_head_uuid: this.form_id,
          keywords: "",
          page: this.page,
          pagesize: this.limit,
        };
        if (this.form_head_uuid === "403e15205bc248f48d8a3626571c4e56") {
          obj.type = 1;
        } else if (this.form_head_uuid === "91e9bb4eac0a48b38e8327cc9c6c23de") {
          obj.type = 2;
          obj.process_status = 2;
        } else {
          obj.type = 2;
          obj.process_status = 99;
        }
        const { result } = await todolist(obj);
        this.total = result.allcount || 0;
        if (Array.isArray(result.list)) {
          this.orderList = await Promise.all(
            result.list.map(async (el) => ({
              ...el,
              ...(await this.todolistShow(el.id, el.node_uuid, el.work_flows_uuid)),
            }))
          );
        } else {
          this.orderList = [];
        }
      } catch (e) {
        console.error("获取审批列表失败:", e);
        this.orderList = [];
      } finally {
        this.loading = false;
      }
    },
    async todolistShow(id, node_uuid, work_flows_uuid) {
      try {
        const { result } = await todolistShow({
          application_id: this.application_id,
          id,
          node_uuid,
          work_flows_uuid,
        });
        return {
          fields_value_json_show: result.basicinfo ? result.basicinfo.fields_value_json_show : {},
          form_head_uuid: result.basicinfo ? result.basicinfo.form_head_uuid : '',
        };
      } catch (e) {
        return { fields_value_json_show: {}, form_head_uuid: '' };
      }
    },
    // 切换页数
    handleCurrentChange(page) {
      this.page = page;
      this.checkList = [];
      this.todolist();
    },
    handleSizeChange(limit) {
      this.page = 1;
      this.limit = limit;
      this.checkList = [];
      this.todolist();
    },
    navTo(route) {
      if (!route) return;
      this.$store.commit("setData", {
        form_head_uuid: this.form_head_uuid,
      });
      this.$router.push(route);
    },
    // 单项审批
    handleApproval(value, status) {
      const {
        id,
        node_uuid,
        todo_id,
        work_flows_uuid,
        fields_value_json_show,
      } = value;
      this.$confirm(
        status === 1 ? "确认通过该项审批？" : "确认驳回该项审批？",
        "审批确认",
        {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: status === 1 ? "info" : "warning",
        }
      )
        .then(async () => {
          await checktodo({
            application_id: this.application_id,
            approve_upload_file: [],
            content: "",
            data: {
              id: fields_value_json_show ? fields_value_json_show.id : id,
            },
            editjson: {},
            id,
            isedit: 0,
            node_uuid,
            rejectinfo: {},
            signature_file: "",
            todo_id,
            status,
            work_flows_uuid,
          });
          this.$message.success(status === 1 ? "审批已通过" : "审批已驳回");
          this.page = 1;
          this.checkList = [];
          this.todolist();
        })
        .catch(() => { });
    },
    // 批量审批
    async handleBatchApproval(status) {
      let batch_info = this.checkList.map((el) => {
        const {
          id,
          node_uuid,
          todo_id,
          work_flows_uuid,
          fields_value_json_show,
        } = el;
        return {
          application_id: this.application_id,
          approve_upload_file: [],
          content: "",
          data: {
            id: fields_value_json_show ? fields_value_json_show.id : id,
          },
          editjson: {},
          id,
          isedit: 0,
          node_uuid,
          rejectinfo: {},
          signature_file: "",
          todo_id,
          status,
          work_flows_uuid,
        };
      });
      const { result } = await approveAllowApprovalBatchAction({
        batch_info,
      });
      this.getQueueText(result.queue_code);
      this.timer = setInterval(() => {
        this.getQueueText(result.queue_code);
      }, 1000);
      this.checkList = [];
      // 显示加载提示
      this.loadingInstance = this.$loading({
        lock: true,
        text: "正在批量处理审批，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    async getQueueText(queue_code) {
      try {
        const { result } = await getQueueText({
          queue_code,
        });
        let status = result.data.status;
        if (status === "success") {
          if (this.loadingInstance) this.loadingInstance.close();
          clearInterval(this.timer);
          this.$message.success(result.data.message || '批量审批执行完毕');
          this.page = 1;
          this.todolist();
        } else if (status === "running") {
          if (this.loadingInstance) this.loadingInstance.text = result.data.message;
        }
      } catch (e) {
        if (this.loadingInstance) this.loadingInstance.close();
        clearInterval(this.timer);
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '../assets/css/var.less';

.gov-approval-list-container {
  width: 100%;

  /* 批量操作工具条 */
  .batch-action-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px 16px;
    margin-bottom: 16px;

    .batch-left {
      strong {
        color: @brandPrimary;
      }
    }

    .batch-right {
      display: flex;
      gap: 10px;
    }
  }

  /* 骨架屏 */
  .approval-skeleton-list {
    display: flex;
    flex-direction: column;
    gap: 14px;

    .sk-order-card {
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      padding: 16px;
      background: #fff;

      .sk-header {
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        padding-bottom: 10px;
        border-bottom: 1px dashed #f1f5f9;
      }

      .sk-body {
        display: flex;
        gap: 16px;

        .sk-img {
          width: 72px;
          height: 72px;
          border-radius: 6px;
          background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
          background-size: 200% 100%;
          animation: sk-shimmer 1.5s infinite;
        }

        .sk-details {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
      }

      .sk-bar {
        height: 16px;
        border-radius: 4px;
        background: linear-gradient(90deg, #f1f5f9 25%, #e2e8f0 50%, #f1f5f9 75%);
        background-size: 200% 100%;
        animation: sk-shimmer 1.5s infinite;

        &.w-20 { width: 20%; }
        &.w-30 { width: 30%; }
        &.w-40 { width: 40%; }
        &.w-60 { width: 60%; }
      }
    }
  }

  @keyframes sk-shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  /* 表头 */
  .orderTableHeader {
    width: 100%;
    height: 42px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px 6px 0 0;
    color: #475569;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;

    span {
      text-align: center;

      &.col-goods {
        flex: 1;
        text-align: left;
        padding-left: 20px;
      }

      &.col-price { width: 140px; }
      &.col-num { width: 140px; }
      &.col-total { width: 140px; }
    }
  }

  /* 列表卡片 */
  .orderList {
    width: 100%;
    list-style: none;
    padding: 0;
    margin: 0;

    .order-card-item {
      border: 1px solid #e2e8f0;
      border-top: none;
      background: #ffffff;
      transition: all 0.2s ease;
      margin-bottom: 12px;
      border-radius: 0 0 6px 6px;

      &:hover {
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.05);
      }

      .orderHeader {
        background-color: #f8fafc;
        border-bottom: 1px solid #f1f5f9;
        height: 44px;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .header-left {
          display: flex;
          align-items: center;
          gap: 12px;

          .orderTime {
            font-size: 13px;
            font-weight: 600;
            color: #1e293b;
            display: flex;
            align-items: center;
            gap: 6px;

            i { color: @brandPrimary; }
          }

          .orderId {
            font-size: 12px;
            color: #64748b;
          }
        }

        .header-right {
          .status-badge {
            font-size: 12px;
            padding: 2px 8px;
            border-radius: 4px;
            font-weight: 600;

            &.badge-reviewing {
              background: #eff6ff;
              color: @brandPrimary;
              border: 1px solid #bfdbfe;
            }

            &.badge-approved {
              background: #ecfdf5;
              color: #10b981;
              border: 1px solid #a7f3d0;
            }

            &.badge-rejected {
              background: #fef2f2;
              color: #ef4444;
              border: 1px solid #fecaca;
            }
          }
        }
      }

      .orderDetail {
        display: flex;
        align-items: center;
        padding: 14px 16px;
        border-bottom: 1px dashed #f1f5f9;

        &:last-of-type {
          border-bottom: none;
        }

        .goods-thumb {
          width: 64px;
          height: 64px;
          border-radius: 6px;
          border: 1px solid #e2e8f0;
          object-fit: cover;
          flex-shrink: 0;
        }

        .goodsName {
          flex: 1;
          padding: 0 16px;

          p {
            margin: 0;
            font-size: 13px;
            line-height: 1.5;
            color: #1e293b;
            font-weight: 500;
            cursor: pointer;

            &:hover {
              color: @brandPrimary;
            }
          }
        }

        .unitPrice, .num, .amount {
          width: 140px;
          text-align: center;
          font-size: 13px;
          flex-shrink: 0;
        }

        .unitPrice { color: #64748b; }
        .num { color: #334155; font-weight: 500; }
        .amount { color: #0f172a; font-weight: 700; }
      }

      .orderfooter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        background: #ffffff;
        border-top: 1px solid #f1f5f9;

        .footer-left {
          .total-sum {
            font-size: 13px;
            color: #64748b;

            em {
              font-style: normal;
              font-weight: 700;
              font-size: 15px;
              color: #e11d48;
              margin-left: 4px;
            }
          }
        }

        .footer-right {
          display: flex;
          gap: 10px;
        }
      }
    }
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0 0;
  }

  /* 规范空状态 */
  .empty-gov-state {
    padding: 60px 0;
    text-align: center;
    background: #ffffff;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;
    margin-top: 16px;

    .icon-circle {
      width: 60px;
      height: 60px;
      margin: 0 auto 14px;
      border-radius: 50%;
      background: #eff6ff;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        font-size: 28px;
        color: @brandPrimary;
      }
    }

    .empty-title {
      font-size: 15px;
      font-weight: 600;
      color: #334155;
      margin: 0 0 6px;
    }

    .empty-sub {
      font-size: 13px;
      color: #94a3b8;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ApprovalList.vue